module.exports = __webpack_public_path__ + "static/media/sewage-01.7a7c256e.svg";